// extracted by mini-css-extract-plugin
export var button = "_cb-2";
export var iconWrapper = "_cb-0";
export var investigatingIcon = "_cb-1";